/* Mr Mattress: never land on a size and length that does not exist.
   Super King is only made in Extra Length, so picking Super King while Standard Length is selected used to show
   "Unavailable". When a pick makes a combination that has no variant, this moves the other options to the closest
   real variant (keeping as many of the customer's picks as possible) BEFORE the theme's variant picker reads them.
   Variant list comes from script[data-mm-combos] rendered in snippets/variant-main-picker.liquid. */
(function () {
  'use strict';
  if (window.__mmVariantFix) return;
  window.__mmVariantFix = true;

  function dataFor(picker) {
    var el = picker.querySelector('script[data-mm-combos]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function optionNameOf(ctrl, picker) {
    if (ctrl.tagName === 'SELECT') {
      var m = /^options\[(.*)\]$/.exec(ctrl.name || '');
      return m ? m[1] : null;
    }
    if (ctrl.type === 'radio') {
      var suffix = '-' + picker.dataset.blockId + '-' + picker.dataset.productId;
      var n = ctrl.name || '';
      return n.length > suffix.length && n.slice(-suffix.length) === suffix ? n.slice(0, -suffix.length) : null;
    }
    return null;
  }

  function controlsFor(picker) {
    var map = {};
    [].forEach.call(picker.querySelectorAll('select[name^="options["]'), function (s) {
      var n = optionNameOf(s, picker);
      if (n) map[n] = { sel: s };
    });
    [].forEach.call(picker.querySelectorAll('fieldset input[type="radio"]'), function (r) {
      var n = optionNameOf(r, picker);
      if (!n) return;
      if (!map[n]) map[n] = { radios: [] };
      if (map[n].radios) map[n].radios.push(r);
    });
    return map;
  }

  function currentValue(c) {
    if (c.sel) return c.sel.value;
    for (var i = 0; i < c.radios.length; i++) if (c.radios[i].checked) return c.radios[i].value;
    return null;
  }

  function setValue(c, val) {
    if (c.sel) {
      var found = null;
      [].forEach.call(c.sel.options, function (o) {
        o.removeAttribute('selected');
        if (o.value === val) found = o;
      });
      if (found) { found.disabled = false; found.setAttribute('selected', 'selected'); c.sel.value = val; }
      return !!found;
    }
    for (var i = 0; i < c.radios.length; i++) {
      if (c.radios[i].value === val) { c.radios[i].checked = true; return true; }
    }
    return false;
  }

  /* capture phase on document: runs before the variant picker's own change listener */
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.closest || t.closest('[data-mm-bed]')) return;
    var picker = t.closest('variant-picker');
    if (!picker) return;
    var d = dataFor(picker);
    if (!d || !d.names || !d.v) return;
    var name = optionNameOf(t, picker);
    var idx = name ? d.names.indexOf(name) : -1;
    if (idx < 0) return;

    var ctrls = controlsFor(picker);
    var newVal = t.value;
    var cur = d.names.map(function (n, i) {
      if (i === idx) return newVal;
      var c = ctrls[n];
      return c ? currentValue(c) : null;
    });

    for (var k = 0; k < d.v.length; k++) {
      var ok = true;
      for (var i = 0; i < cur.length; i++) if (cur[i] !== null && d.v[k].o[i] !== cur[i]) { ok = false; break; }
      if (ok) return; /* the combination exists, let the theme carry on as normal */
    }

    var best = null, bestScore = -1;
    d.v.forEach(function (v) {
      if (v.o[idx] !== newVal) return;
      var s = v.a ? 100 : 0;
      for (var i = 0; i < cur.length; i++) if (i !== idx && cur[i] !== null && v.o[i] === cur[i]) s += 2;
      if (s > bestScore) { best = v; bestScore = s; }
    });
    if (!best) return;

    d.names.forEach(function (n, i) {
      if (i === idx) return;
      var c = ctrls[n];
      if (c && cur[i] !== best.o[i]) setValue(c, best.o[i]);
    });

    /* so the theme writes the real variant into the page address */
    var opt = t.tagName === 'SELECT' ? t.options[t.selectedIndex] : t;
    if (opt) opt.dataset.variantId = String(best.id);
  }, true);
})();
